import React, { useState } from "react"
import { Tag, Typography, Avatar, Button, Flex, Card } from "antd"
import { EllipsisOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import IconWithBg from "ui/IconWithBg"
import CustomDrawer from "ui/Drawer"
import { EditIcon, TrashIcon } from "icons"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { routes } from "router/routes"

const CrewMobileCardList = ({ data, handleEdit, handleActivate, handleDeactivate, handleDelete }) => {
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false)
  const [selectedCrew, setSelectedCrew] = useState(null)
  const { t } = useTranslation()

  const openDrawerFilter = (crew) => {
    setOpenFilterDrawer(true)
    setSelectedCrew(crew)
  }

  return (
    <>
      <Flex vertical gap={16}>
        {data.map((crew) => (
          <>
            <Card className={styles.card} key={crew.id}>
              <Flex gap={10} align="center">
                <div className="flex-1">
                  <Flex align="flex-start" gap={16}>
                    <Avatar src={crew.image} size={65} />
                    <Flex vertical style={{ flex: 1, minWidth: 0 }}>
                      <Flex align="center" gap={8} wrap className={styles.nameRow}>
                        <Link to={routes.guideCrewMemberDetailsPath({ id: crew.id })} className={styles.name}>
                          {crew.name}
                        </Link>
                        <Flex gap={8}>
                          {crew.status && (
                            <Tag color={crew.status === "active" ? "green" : "red"} className={styles.commonTag}>
                              {crew.status}
                            </Tag>
                          )}
                          {crew?.role && (
                            <Tag color="blue" className={styles.commonTag}>
                              {crew?.role}
                            </Tag>
                          )}
                        </Flex>
                      </Flex>
                      <Flex align="center" gap={8} style={{ color: "var(--color-text-secondary-dark)", fontSize: "0.98rem", marginTop: 2 }}>
                        {crew?.title && (
                          <>
                            <Typography.Text type="secondary">{crew?.title}</Typography.Text>
                            <span className={styles.dot} />
                          </>
                        )}
                        <Typography.Text type="secondary">{crew.phoneNumber}</Typography.Text>
                      </Flex>
                    </Flex>
                  </Flex>
                  <Flex justify="space-between" className={`mt-s ${styles.detailsRow}`}>
                    <Flex gap={5} className="w-full">
                      <Typography.Text type="secondary" block className={styles.label}>
                        Assigned to:
                      </Typography.Text>
                      <Typography.Text className={styles.value}>{crew.assignedTo} experiences</Typography.Text>
                    </Flex>
                    <Flex gap={5} className="w-full">
                      <Typography.Text type="secondary" block className={styles.label}>
                        Availability:
                      </Typography.Text>
                      <Typography.Text className={styles.value}>{crew.availabilityTime || "-"}</Typography.Text>
                    </Flex>
                  </Flex>
                  <Flex justify="space-between" className={styles.detailsRow}>
                    <Flex gap={5} className="w-full">
                      <Typography.Text type="secondary" block className={styles.label}>
                        Upcoming:
                      </Typography.Text>
                      <Typography.Text className={styles.value}>{crew.upcomingBookings} bookings</Typography.Text>
                    </Flex>
                    <Flex gap={5} className="w-full">
                      <Typography.Text type="secondary" block className={styles.label}>
                        Next Time Off:
                      </Typography.Text>
                      <Typography.Text className={styles.value}>{crew.nextTimeOff || "-"}</Typography.Text>
                    </Flex>
                  </Flex>
                </div>
                <IconWithBg onClick={() => openDrawerFilter(crew)} icon={<EllipsisOutlined />} className={styles.moreBtn} />
              </Flex>
              {/* <Button type="text" icon={<EllipsisOutlined />} className={styles.moreBtn} /> */}
            </Card>
          </>
        ))}
        <CustomDrawer open={openFilterDrawer} title="Actions" setOpen={() => setOpenFilterDrawer(!openFilterDrawer)}>
          <Flex vertical gap={10} className={`w-full`}>
            <Button color="primary" variant="outlined" size="large" onClick={() => handleEdit(selectedCrew)} className={`w-full`}>
              <EditIcon /> {t("resources.edit") || "Edit"}
            </Button>
            {selectedCrew?.status === "active" ? (
              <Button color="primary" variant="outlined" size="large" onClick={() => handleDeactivate(selectedCrew)} className={`w-full`}>
                <EditIcon /> {t("resources.disable") || "Disable"}
              </Button>
            ) : (
              <Button color="primary" variant="outlined" size="large" onClick={() => handleActivate(selectedCrew)} className={`w-full`}>
                <EditIcon /> {t("resources.make_active") || "Make Active"}
              </Button>
            )}
            <Button color="danger" variant="outlined" size="large" onClick={() => handleDelete(selectedCrew)} className={`w-full`}>
              <TrashIcon /> {t("resources.delete") || "Delete"}
            </Button>
          </Flex>
        </CustomDrawer>
      </Flex>
    </>
  )
}

export default CrewMobileCardList
